var React = require('react');

function ContactBackgroundBlob (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M646.151 7.81215C838.325 31.4258 977.559 168.661 1094.58 316.249C1206.77 457.731 1311.51 621.089 1269.54 794.016C1227.7 966.408 1048.72 1052.09 892.832 1147.59C691.857 1270.72 495.113 1479.4 268.669 1407.18C28.4649 1330.57 -71.5693 1062.67 -118.9 824.917C-163.805 599.351 -134.872 355.972 25.3349 184.864C176.844 23.0457 420.8 -19.878 646.151 7.81215Z","fill":"#9C27B0"}));
}

ContactBackgroundBlob.defaultProps = {"width":"1279","height":"1422","viewBox":"0 0 1279 1422","fill":"none"};

module.exports = ContactBackgroundBlob;

ContactBackgroundBlob.default = ContactBackgroundBlob;
